import { NavigateBeforeOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";
import TreeIcon from "../svgs/TreeIcon";
import HeaderContainer from "../HeaderContainer";
import useWindowSize from "../../hooks/useWindowSize";
import { Button } from "react-bootstrap";

const Container = ({ children, titulo, linkBack, size, tituloApp }) => {
  const tamaño = useWindowSize();
  const { width } = tamaño;

  return (
    <section
      className={` ${
        size == "sm"
          ? "col-12 col-sm-10 col-md-9 col-lg-8 col-xl-7 col-xxl-6 "
          : size == "md"
          ? "col-md-12 col-lg-10 col-xl-9"
          : "col-12"
      } mx-auto mb-5  `} /* style={{ minHeight: "80vh" }} */
    >
      <div className={`${width >= 640 && "container_menu p-3 rounded"}`}>
        <div className="bg-white p-3 rounded">
          {
            // <HeaderContainer tituloApp={"ARBOLADO"} />
            <HeaderContainer tituloApp={tituloApp} />
          }
          {tituloApp && <hr />}
          {/* <div className="alert alert-warning">
            Esta es una versión primaria del sistema que solo posee acceso a la carga de podadores
            junto con sus observaciones y los barrios junto con sus jefes de comisión
          </div> */}
          {/* <div className="d-flex justify-content-center align-items-center"> */}

          {linkBack && (
            <>
              {typeof linkBack == "string" ? (
                <div className="d-flex justify-content align-items-center">
                  <Link to={linkBack} className="btn btn-primary btn-sm ">
                    <NavigateBeforeOutlined /> Volver
                  </Link>
                  {/* {linkBack != "/" && (
                <Link to={"/"} className="btn btn-primary btn-sm align-items-center d-flex mx-2">
                  Menú
                </Link>
              )} */}
                </div>
              ) : (
                <Button onClick={() => linkBack()} className="btn btn-primary btn-sm ">
                  <NavigateBeforeOutlined /> Volver
                </Button>
              )}
            </>
          )}

          {/* //!SE CAMBIO */}
          {/* {
            tituloApp &&
            <>
              <div className="d-flex gap-3 align-items-end w-100 justify-content-center">
                <TreeIcon width={"30px"} color={"#005E2B"} />
                <h3 className=" text-center m-0 fs-3 " style={{ lineHeight: "24px", color: "#005E2B" }}>{tituloApp}</h3>
                <TreeIcon width={"30px"} color={"#005E2B"} />
              </div>
              <hr className="m-0 mt-3" />
            </>
          } */}

          {titulo && (
            <h3
              className={`col-12 text-center align-items-center pb-3  mt-3 fs-4 ${
                width < 640 && "mb-3"
              } `}
            >
              {titulo}
            </h3>
          )}
          {children}
        </div>
      </div>
    </section>
  );
};

export default Container;
